import HttpRequest from './core/http_request';

class SurveyProvider extends HttpRequest {
  getStatus (data) {
    return this.request('get', '/uploadFile');
  }

  getSurvey (data) {
    return this.request('get', '/survey/surveyLichen', data);
  }

  getMySurveylichen (data) {
    return this.request('get', '/survey/mysurveylichen', data);
  }

  saveSurvey (data) {
    return this.request('post', '/survey/save');
  }

  saveSurveyLichen (data) {
    return this.request('post', '/survey/surveyLichen', data);
  }

  uploadFileLichen (data) {
    return this.request('upload', '/uploadFile/uploadLichenFile', data);
  }

  getSurveyLichen (data) {
    const id = data._id;
    return this.request('get', '/survey/surveyLichen/id/' + id, data);
  }

  updateSurveyLichen (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveyLichen/id/' + id, data);
  }

  // cropdamage
  saveSurveyCropDamage (data) {
    return this.request('post', '/survey/surveycorpDamage', data);
  }

  uploadFileCrop (data) {
    return this.request('upload', '/uploadFile/uploadCorpDamageFile', data);
  }

  getSurveyCropDamage (data) {
    return this.request('get', '/survey/surveycorpDamage', data);
  }

  getMySurveyCorpDamage (data) {
    return this.request('get', '/survey/mySurveyCorpDamage', data);
  }

  updateSurveyCropDamage (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveycorpDamage/id/' + id, data);
  }

  deleteSampleans (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/deleteSampleans/id/' + id, data);
  }

  getSurveyCropDamageAnswer (data) {
    const id = data._id;
    delete data._id;
    return this.request('get', '/survey/surveycorpDamage/id/' + id, data);
  }

  getSurveyCropOne (data) {
    const id = data._id;
    return this.request('get', '/survey/surveycorpDamage/id/' + id, data);
  }

  corpdamageUpdateStatus (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveycorpDamage/updateStatus/' + id, data);
  }

  getCropdamageRpt (data) {
    return this.request('get', '/survey/surveycorpDamage/report', data);
  }

  getMyCropdamageRpt (data) {
    return this.request('get', '/survey/surveycorpDamage/myReport', data);
  }

  getCropdamageImageList (data) {
    return this.request('get', '/survey/surveycorpDamage/cropdamageimage', data);
  }

  getCropdamageImageListByAnsID (data) {
    const id = data._id;
    delete data._id;
    return this.request('get', '/survey/surveycorpDamage/cropdamageimage/' + id, data);
  }
  // End cropdamage

  // Bioblitz
  uploadFileBioblitz (data) {
    return this.request('upload', '/uploadFile/uploadBioblitzFile', data);
  }

  saveSurveyBioblitz (data) {
    return this.request('post', '/survey/surveyBioBlitz', data);
  }

  getSurveyBioblitzAnsList (data) {
    return this.request('get', '/survey/surveyBioBlitz', data);
  }

  getMySurveyBioBlitz (data) {
    return this.request('get', '/survey/mySurveyBioBlitz', data);
  }

  getSurveyBioblitz (data) {
    const id = data._id;
    return this.request('get', '/survey/surveyBioBlitz/id/' + id, data);
  }

  updateSurveyBioblitz (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveyBioBlitz/id/' + id, data);
  }

  getSurveyBioblitzRpt (data) {
    return this.request('get', '/survey/surveyBioBlitz/report', data);
  }

  getBioblitzImageList (data) {
    return this.request('get', '/survey/surveyBioBlitz/bioblitzimage', data);
  }

  getBioblitzImageListByAnsID (data) {
    const id = data._id;
    delete data._id;
    return this.request('get', '/survey/surveyBioBlitz/bioblitzimage/' + id, data);
  }

  getSurveyBioblitzMyRpt () {
    return this.request('get', '/survey/surveyBioBlitz/myReport');
  }

  getMyBioblitzImageList (data) {
    return this.request('get', '/survey/surveyBioBlitz/myBioblitzimage', data);
  }
  // end Bioblitz

  uploadFileAgriculturalproduct (data) {
    return this.request('upload', '/uploadFile/uploadAgriculturalproductFile', data);
  }

  saveSurveyAgriculturalproduct (data) {
    return this.request('post', '/survey/surveyAgriculturalproduct', data);
  }

  getSurveyAgriculturalproductAnsList (data) {
    return this.request('get', '/survey/surveyAgriculturalproduct', data);
  }

  getMySurveyAgriculturalProduct (data) {
    return this.request('get', '/survey/mySurveyAgriculturalProduct', data);
  }

  getSurveyAgriculturalproduct (data) {
    const id = data._id;
    return this.request('get', '/survey/surveyAgriculturalproduct/id/' + id, data);
  }

  getSurveyAgriculturalproductChart (data) {
    return this.request('get', '/survey/surveyAgriculturalProductChart', data);
  }

  getMySurveyAgriculturalproductRpt () {
    return this.request('get', '/survey/surveyAgriculturalProduct/myReport');
  }

  updateSurveyAgriculturalproduct (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveyAgriculturalproduct/id/' + id, data);
  }

  /* surveyAgriculturalProduct */
  updateSurveyPhysicalhealth (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveyPhysicalhealth/id/' + id, data);
  }

  saveSurveyPhysicalhealth (data) {
    return this.request('post', '/survey/surveyPhysicalhealth', data);
  }

  getSurveyPhysicalhealthAnsList (data) {
    return this.request('get', '/survey/surveyPhysicalhealth', data);
  }

  getMySurveyPhysicalHealth (data) {
    return this.request('get', '/survey/mySurveyPhysicalHealth', data);
  }

  getSurveyPhysicalhealth (data) {
    const id = data._id;
    return this.request('get', '/survey/surveyPhysicalhealth/id/' + id, data);
  }

  getMySurveyPhysicalhealthRpt () {
    return this.request('get', '/survey/surveyPhysicalHealth/myReport');
  }
  /* end surveyAgriculturalProduct */

  /* sampleno2survey */
  saveSurveySampleno2 (data) {
    return this.request('post', '/survey/surveySampleNo2', data);
  }

  updateSurveySampleno2 (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveySampleNo2/id/' + id, data);
  }

  getSurveySampleno2List (data) {
    return this.request('get', '/survey/surveySampleNo2', data);
  }

  getMySurveySampleNO2 (data) {
    return this.request('get', '/survey/mySurveySampleNO2', data);
  }

  getSurveySampleno2 (data) {
    const id = data._id;
    return this.request('get', '/survey/surveySampleNo2/id/' + id, data);
  }

  uploadSampleNO2File (data) {
    return this.request('upload', '/uploadFile/uploadSampleNO2File', data);
  }
  /* end sampleno2survey */

  /* samplerainwatersurvey */
  saveSurveySamplenrain (data) {
    return this.request('post', '/survey/surveySamplerain', data);
  }

  updateSurveySamplenrain (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveySamplerain/id/' + id, data);
  }

  getSurveySamplenrainList (data) {
    return this.request('get', '/survey/surveySamplerain', data);
  }

  getMySurveySampleRain (data) {
    return this.request('get', '/survey/mySurveySampleRain', data);
  }

  getSurveySamplenrain (data) {
    const id = data._id;
    return this.request('get', '/survey/surveySamplerain/id/' + id, data);
  }

  uploadSampleRainFile (data) {
    return this.request('upload', '/uploadFile/uploadSampleRainFile', data);
  }

  getSampleRainRpt (data) {
    return this.request('get', '/survey/surveySampleRain/report', data);
  }
  /* end samplerainwatersurvey */

  /* samplewatersurvey */
  saveSurveySamplewater (data) {
    return this.request('post', '/survey/surveySamplewater', data);
  }

  updateSurveySamplewater (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveySamplewater/id/' + id, data);
  }

  getSurveySamplewaterList (data) {
    return this.request('get', '/survey/surveySamplewater', data);
  }

  getMySurveySampleWater (data) {
    return this.request('get', '/survey/mySurveySampleWater', data);
  }

  getSurveySamplewater (data) {
    const id = data._id;
    return this.request('get', '/survey/surveySamplewater/id/' + id, data);
  }

  uploadSampleWaterFile (data) {
    return this.request('upload', '/uploadFile/uploadSampleWaterFile', data);
  }

  getSampleWaterRpt (data) {
    return this.request('get', '/survey/surveySampleWater/report', data);
  }

  getMySampleWaterRpt (data) {
    return this.request('get', '/survey/surveySampleWater/myReport', data);
  }
  /* end samplewatersurvey */

  /* orangeorchardsurvey */
  saveSurveyOrangeorchard (data) {
    return this.request('post', '/survey/surveyOrangeorchard', data);
  }

  updateSurveyOrangeorchard (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveyOrangeorchard/id/' + id, data);
  }

  getSurveyOrangeorchardList (data) {
    return this.request('get', '/survey/surveyOrangeorchard', data);
  }

  getMySurveyOrangeOrchard (data) {
    return this.request('get', '/survey/mySurveyOrangeOrchard', data);
  }

  getSurveyOrangeorchard (data) {
    const id = data._id;
    return this.request('get', '/survey/surveyOrangeorchard/id/' + id, data);
  }
  /* end orangeorchardsurvey */

  /* SPST20Survey */
  saveSurveySPST20 (data) {
    return this.request('post', '/survey/surveySPST20', data);
  }

  updateSurveySPST20 (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveySPST20/id/' + id, data);
  }

  getSurveySPST20List (data) {
    return this.request('get', '/survey/surveySPST20', data);
  }

  getMySurveySPST20 (data) {
    return this.request('get', '/survey/mySurveySPST20', data);
  }

  getSurveySPST20 (data) {
    const id = data._id;
    return this.request('get', '/survey/surveySPST20/id/' + id, data);
  }

  getMySPST20Chart () {
    return this.request('get', '/survey/surveySPST20/myReport');
  }
  /* end SPST20Survey */

  /* MercurySurvey */
  saveSurveyMercury (data) {
    return this.request('post', '/survey/surveyMercury', data);
  }

  updateSurveyMercury (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveyMercury/id/' + id, data);
  }

  getSurveyMercuryList (data) {
    return this.request('get', '/survey/surveyMercury', data);
  }

  getMySurveyMercury (data) {
    return this.request('get', '/survey/mySurveyMercury', data);
  }

  getSurveyMercury (data) {
    const id = data._id;
    return this.request('get', '/survey/surveyMercury/id/' + id, data);
  }

  uploadFileMercury (data) {
    return this.request('upload', '/uploadFile/uploadMercuryFile', data);
  }

  updateStatusReseracher (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveyMercury/updateStatus/' + id, data);
  }

  getMercuryRpt (data) {
    return this.request('get', '/survey/surveyMercury/report', data);
  }

  getMyMercuryRpt (data) {
    return this.request('get', '/survey/surveyMercury/myReport', data);
  }

  getMercuryImageList (data) {
    return this.request('get', '/survey/surveyMercury/mercuryimage', data);
  }

  getMercuryImageListByAnsID (data) {
    const id = data._id;
    delete data._id;
    return this.request('get', '/survey/surveyMercury/mercuryimage/' + id, data);
  }
  /* end MercurySurvey */

  /* Smoke and sound survey */
  saveSurveySmokeAndSound (data) {
    return this.request('post', '/survey/surveySmokeAndSound', data);
  }

  updateSmokeAndSound (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveySmokeAndSound/id/' + id, data);
  }

  getSmokeAndSoundList (data) {
    return this.request('get', '/survey/surveySmokeAndSound', data);
  }

  getMySmokeAndSound (data) {
    return this.request('get', '/survey/mySurveySmokeAndSound', data);
  }

  getSmokeAndSound (data) {
    const id = data._id;
    return this.request('get', '/survey/surveySmokeAndSound/id/' + id, data);
  }

  uploadFileSmokeandsound (data) {
    return this.request('upload', '/uploadFile/uploadSmokeAndSoundFile', data);
  }
  /* End Smoke and sound survey */

  saveSurveyLichen2 (data) {
    return this.request('post', '/survey/surveyLichen', data);
  }

  getServeyLichen2 (data) {
    return this.request('get', '/survey/surveyLichen/id/' + data._id, data);
  }

  updateLichen2 (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveyLichen/id/' + id, data);
  }

  getLichenans2 (data) {
    return this.request('get', '/survey/mysurveylichen', data);
  }

  // =============================================== Bentic ===============================================
  getBentic (data) {
    return this.request('get', '/survey/benthicclassify', data);
  }

  getBenticByAnsId (data) {
    const id = data._id;
    return this.request('get', '/survey/benthicclassify/ansid/' + id);
  }

  saveComment (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/benthicclassify/addcomment/' + id, data);
  }

  vote (data) {
    return this.request('post', '/survey/benthicclassify/vote', data);
  }

  voteY (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/benthicclassify/voteY/' + id, data);
  }

  voteN (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/benthicclassify/voteN/' + id, data);
  }

  getBenthicById (data) {
    const id = data._id;
    delete data._id;
    return this.request('get', '/survey/benthicclassify/id/' + id, data);
  }

  updateBenthictComment (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/benthicclassify/updatecomment/' + id, data);
  }
  // =============================================== End Bentic ===============================================

  /** ============================================================================================================= */
  /** =============================================== for guest =================================================== */
  /** ============================================================================================================= */

  /* SPST20Survey2 */
  saveSurveySPST202 (data) {
    return this.request('post', '/survey/surveySPST202', data);
  }

  updateSurveySPST202 (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveySPST202/id/' + id, data);
  }

  getSurveySPST202List (data) {
    return this.request('get', '/survey/surveySPST202', data);
  }

  getMySurveySPST202 (data) {
    return this.request('get', '/survey/mySurveySPST202', data);
  }

  getSurveySPST202 (data) {
    const id = data._id;
    return this.request('get', '/survey/surveySPST202/id/' + id, data);
  }
  /* end SPST20Survey2 */

  /** Physicalhealth2 */
  updateSurveyPhysicalhealth2 (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveyPhysicalhealth2/id/' + id, data);
  }

  saveSurveyPhysicalhealth2 (data) {
    return this.request('post', '/survey/surveyPhysicalhealth2', data);
  }

  getSurveyPhysicalhealth2AnsList (data) {
    return this.request('get', '/survey/surveyPhysicalhealth2', data);
  }

  getMySurveyPhysicalHealth2 (data) {
    return this.request('get', '/survey/mySurveyPhysicalHealth2', data);
  }

  getSurveyPhysicalhealth2 (data) {
    const id = data._id;
    return this.request('get', '/survey/surveyPhysicalhealth2/id/' + id, data);
  }
  /** End Physicalhealth2 */

  /** Bioblitz2 */
  uploadFileBioblitz2 (data) {
    return this.request('upload', '/uploadFile/uploadBioblitz2File', data);
  }

  saveSurveyBioblitz2 (data) {
    return this.request('post', '/survey/surveyBioBlitz2', data);
  }

  getSurveyBioblitz2AnsList (data) {
    return this.request('get', '/survey/surveyBioBlitz2', data);
  }

  getMySurveyBioBlitz2 (data) {
    return this.request('get', '/survey/mySurveyBioBlitz2', data);
  }

  getSurveyBioblitz2 (data) {
    const id = data._id;
    return this.request('get', '/survey/surveyBioBlitz2/id/' + id, data);
  }

  updateSurveyBioblitz2 (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveyBioBlitz2/id/' + id, data);
  }
  /** end Bioblitz2 */

  // Get Lat Lng from image 31/10/2024
  getLatLngImage (data) {
    return this.request('upload', '/uploadFile/getlatlngimage', data);
  }

  /** OrchardYield */
  uploadFileOrangeorchard (data) {
    return this.request('upload', '/uploadFile/uploadOrangeOrchardFile', data);
  }

  uploadFileOrangeorchardExcel (data) {
    return this.request('upload', '/survey/uploadOrchardYieldExcel', data);
  }

  getSurveyOrangeYieldList (data) {
    return this.request('get', '/survey/surveyOrchardYield', data);
  }

  // updateSurveyOrangeYieldList (data) {
  //   const id = data._id;
  //   delete data._id;
  //   return this.request('post', '/survey/surveyOrchardYield/id/' + id, data);
  // }

  getSurveyOrangeChart (data) {
    return this.request('get', '/survey/surveyOrchardChart', data);
  }

  getMySurveyOrchardYield (data) {
    return this.request('get', '/survey/mySurveyOrchardYield', data);
  }

  saveSurveyOrchardYield (data) {
    return this.request('post', '/survey/surveyOrchardYield', data);
  }

  updateSurveyOrchardYield (data) {
    const id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveyOrchardYield/id/' + id, data);
  }

  getSurveyOrchardYield (data) {
    const id = data._id;
    return this.request('get', '/survey/surveyOrchardYield/id/' + id, data);
  }
  /** end OrchardYield */

  /** PhysicalHealth Pruke */
  getPhysicalHealthChart (data) {
    return this.request('get', '/survey/surveyPhysicalHealthChart', data);
  }
  /** end PhysicalHealth */

  /** SPST20 Pruke */
  getSPST20Chart (data) {
    return this.request('get', '/survey/surveySPST10Chart', data);
  }
  /** end SPST20 Pruke */
  /** ============================================================================================================= */
  /** ============================================= end for guest ================================================= */
  /** ============================================================================================================= */

  // envHeavyMetal
  generateSampleCodeHeavyMetal (data) {
    return this.request('post', '/survey/runningCode/generate', data);
  }

  uploadFileEnvHeavyMetal (data) {
    return this.request('upload', '/uploadFile/uploadEnvHeavyMetalFile', data);
  }

  saveEnvHeavyMetalSurvey (data) {
    return this.request('post', '/survey/surveyEnvHeavyMetal', data);
  }

  updateEnvHeavyMetalSurvey (data) {
    const refId = data.refId;
    delete data.refId;
    return this.request('post', '/survey/surveyEnvHeavyMetal/' + refId, data);
  }

  getEnvHeavyMetalSurveyByRefId (data) {
    return this.request('get', '/survey/surveyEnvHeavyMetal/' + data.refId);
  }

  getEnvHeavyMetalSurveyMyList (data) {
    return this.request('get', '/survey/surveyEnvHeavyMetal/myList', data);
  }

  deleteEnvHeavyMetalSurvey (data) {
    const _id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveyEnvHeavyMetal/delete/' + _id, data);
  }

  getEnvHeavyMetalSurveyListMap (data) {
    return this.request('get', '/survey/surveyEnvHeavyMetal/map', data);
  }

  updateReceiptEnvHeavyMetalSurvey (data) {
    const _id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveyEnvHeavyMetal/receipt/' + _id, data);
  }

  // admin
  getEnvHeavyMetalSurveyList (data) {
    return this.request('get', '/survey/surveyEnvHeavyMetal/list', data);
  }

  // researcher
  updateResultLabEnvHeavyMetal (data) {
    return this.request('post', '/survey/surveyEnvHeavyMetal/researcher/lab', data);
  }

  updateStatusEnvHeavyMetalSurvey (data) {
    const _id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveyEnvHeavyMetal/researcher/status/' + _id, data);
  }

  cancelStatusEnvHeavyMetalSurvey (data) {
    const _id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveyEnvHeavyMetal/researcher/cancel/' + _id, data);
  }

  getEnvHeavyMetalRpt (data) {
    return this.request('get', '/survey/surveyEnvHeavyMetal/report', data);
  }
  // end researcher

  // draft
  saveDraftEnvHeavyMetalSurvey (data) {
    return this.request('post', '/survey/surveyEnvHeavyDraft', data);
  }

  updateDraftEnvHeavyMetalSurvey (data) {
    const refId = data.refId;
    delete data.refId;
    return this.request('post', '/survey/surveyEnvHeavyDraft/' + refId, data);
  }

  getDraftEnvHeavyMetalSurveyByRefId (data) {
    return this.request('get', '/survey/surveyEnvHeavyDraft/' + data.refId);
  }

  getDraftEnvHeavyMetalSurveyMyList (data) {
    return this.request('get', '/survey/surveyEnvHeavyDraft', data);
  }

  deleteDraftEnvHeavyMetalSurvey (data) {
    const _id = data._id;
    delete data._id;
    return this.request('post', '/survey/surveyEnvHeavyDraft/delete/' + _id, data);
  }
  // end draft
  // end envHeavyMetal
}

export default SurveyProvider;
